import React from "react";
import { Outlet } from "react-router-dom";
import { useSessionContext } from '@contexts';

const GuarantorRoute = () => {

    const { session } = useSessionContext();

    if (session && session.isGuarantor) {
        return <Outlet />;
    }
    return (<div>Unauthorized</div>);
};


export default GuarantorRoute;